import { useState } from 'react';
import { isFlagStatusEnabled } from '@gonfalon/dogfood-flags/dogfood-flags';
import { getFeatureFlagStatusesQuery } from '@gonfalon/rest-api/queries/flags';
import { useQuery } from '@tanstack/react-query';

interface UseHasFlagEvaluatedProps {
  projectKey: string;
  flagKey: string;
  environmentKey: string;
  enabled?: boolean;
}

export const useHasFlagEvaluated = ({
  projectKey,
  flagKey,
  environmentKey,
  enabled = true,
}: UseHasFlagEvaluatedProps) => {
  const [hasEverEvaluated, setHasEverEvaluated] = useState(false);
  const { data: flagStatus } = useQuery({
    ...getFeatureFlagStatusesQuery({
      projectKey,
      flagKey,
      environmentKeys: [environmentKey],
    }),
    select: (res) => res[environmentKey],
    enabled: isFlagStatusEnabled() && enabled,
    staleTime: hasEverEvaluated ? Infinity : 1000 * 60 * 5,
  });
  const flagHasEvaluated = typeof flagStatus?.lastRequested === 'string';

  if (flagHasEvaluated && !hasEverEvaluated) {
    setHasEverEvaluated(true);
  }

  return flagHasEvaluated;
};
